import { serviceRequest } from 'utils/http';
import { CallbackTimeslotDto, CallbackTimeslotService } from 'common/api';

type UpdateCallbackTime = {
  referralId: string;
  callbackTimeslotDto: CallbackTimeslotDto;
};

export function updateCallbackTimeslotAPI(
  updateCallbackTimeDto: UpdateCallbackTime
) {
  return serviceRequest(() =>
    CallbackTimeslotService.callbackTimeslotControllerCreateCallbackTimeslot(
      updateCallbackTimeDto.referralId,
      {
        ...updateCallbackTimeDto.callbackTimeslotDto,
        siteSelected: true,
        systemSelected: false,
      }
    )
  );
}
